export const Technologies = [
  {
    'id': 1,
    'name': 'HTML',
    'percentage': '90%'
  },
  {
    'id': 2,
    'name': 'CSS',
    'percentage': '90%'
  },
  {
    'id': 3,
    'name': 'JavaScript',
    'percentage': '80%'
  },
  {
    'id': 4,
    'name': 'React',
    'percentage': '80%'
  },
  {
    'id': 5,
    'name': 'React Router',
    'percentage': '80%'
  },
  {
    'id': 6,
    'name': 'Context',
    'percentage': '80%'
  },
  {
    'id': 7,
    'name': 'Redux',
    'percentage': '70%'
  },
  {
    'id': 8,
    'name': 'Styled Components',
    'percentage': '80%'
  },
  {
    'id': 9,
    'name': 'SASS',
    'percentage': '80%'
  },
  {
    'id': 10,
    'name': 'Tailwind CSS',
    'percentage': '80%'
  },
  {
    'id': 11,
    'name': 'Bootstrap',
    'percentage': '70%'
  },
  {
    'id': 12,
    'name': 'Materialize',
    'percentage': '70%'
  },
  {
    'id': 13,
    'name': 'Git y GitHub',
    'percentage': '80%'
  },
  {
    'id': 14,
    'name': 'Firebase',
    'percentage': '70%'
  },
  {
    'id': 15,
    'name': 'API Rest',
    'percentage': '80%'
  }
];
